var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,3.3C113.2,3.3,2.3,114.2,2.3,251c0,136.8,110.9,247.7,247.7,247.7c136.8,0,247.7-110.9,247.7-247.7 C497.7,114.2,386.8,3.3,250,3.3z M317.2,227.1l-2,23.8h-44.9c0,67.7,0,151.5,0,151.5h-60.6c0,0,0-82.7,0-151.5h-30.6v-24v-36.6h30.2 V163c0-25,11.7-63.4,63.8-63.4H320v51.9c0,0-28.6,0-34,0c-5.6,0-13.3,2.8-13.3,14.5v24.3h48.2L317.2,227.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social_facebook.c028339ced50f1a98eb03392b4c1921d.svg";
export { ForwardRef as ReactComponent };